// extracted by mini-css-extract-plugin
export default {"cardWrapper":"LectureCard_cardWrapper__nnpe5","cardWrapper2":"LectureCard_cardWrapper2__jPxR7","img":"LectureCard_img__wZYd9","lectureTitle":"LectureCard_lectureTitle__YogHe"};